import {Box,Container,Typography} from "@mui/material";
import {useAppTheme} from "../../context/ThemeContext";
import stadiumImg from "../../static/Home/stadium.webp";

export default function MotivationalSection(){
  const {colors}=useAppTheme();

  return(
    <Box
      component="section"
      aria-label="La pasión por el fútbol"
      sx={{
        position:"relative",
        width:"100%",
        minHeight:{xs:350,sm:390,md:440},
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        overflow:"hidden",
        backgroundColor:"#041127"
      }}
    >
      <Box
        sx={{
          position:"absolute",
          inset:0,
          backgroundImage:`url(${stadiumImg})`,
          backgroundSize:"cover",
          backgroundPosition:"center",
          backgroundRepeat:"no-repeat"
        }}
      />

      <Box
        sx={{
          position:"absolute",
          inset:0,
          background:"linear-gradient(90deg,rgba(3,12,35,.91) 0%,rgba(4,15,43,.85) 50%,rgba(3,12,35,.91) 100%)"
        }}
      />

      <Container
        maxWidth="lg"
        sx={{
          position:"relative",
          zIndex:1,
          display:"flex",
          flexDirection:"column",
          alignItems:"center",
          justifyContent:"center",
          textAlign:"center",
          px:{xs:3,sm:4,md:5},
          py:{xs:6,sm:7,md:9}
        }}
      >
        <Typography
          sx={{
            width:"100%",
            textAlign:"center",
            fontSize:{xs:11,sm:12},
            fontWeight:500,
            letterSpacing:"0.12em",
            color:"rgba(255,255,255,.75)"
          }}
        >
          PASIÓN · DISCIPLINA · COMPETENCIA
        </Typography>

        <Typography
          component="h2"
          sx={{
            width:"100%",
            maxWidth:900,
            mx:"auto",
            mt:{xs:2.5,md:3},
            mb:0,
            textAlign:"center",
            fontSize:{
              xs:"clamp(1.8rem,6vw,2.4rem)",
              sm:"clamp(2.4rem,4.5vw,3.2rem)",
              md:"clamp(2.8rem,3.5vw,3.7rem)"
            },
            fontWeight:600,
            lineHeight:1.2,
            letterSpacing:"-0.035em",
            color:"#FFFFFF",
            textWrap:"balance"
          }}
        >
          El fútbol no solo se juega con los pies,
          se juega con el corazón.
        </Typography>

        <Typography
          sx={{
            width:"100%",
            maxWidth:720,
            mx:"auto",
            mt:{xs:2,md:2.5},
            textAlign:"center",
            fontSize:{xs:14,sm:15,md:16},
            fontWeight:400,
            lineHeight:1.8,
            color:"rgba(225,235,247,.85)",
            textWrap:"balance"
          }}
        >
          Cada partido es una oportunidad para demostrar entrega,
          carácter y el espíritu competitivo que hace grande
          a este deporte.
        </Typography>

        <Box
          sx={{
            width:64,
            height:3,
            mt:{xs:3,md:3.5},
            mx:"auto",
            backgroundColor:colors.secondary
          }}
        />
      </Container>
    </Box>
  );
}